__webpack_require__.p = "https://repo.byonde.asia/";